// utils
import PadItemMatMed from '../components-js/pad-item/PadItemMatMed';

const TEMPLATE_NAME = 'PAD_EDITOR_ITEM_MATMED';

const initialState = {
  loading: false,
  errors: [],
  data: {
    current: [],
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padEditorMatMed = new PadItemMatMed(state);

      return padEditorMatMed.setLoading().setErrors().getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padEditorMatMed = new PadItemMatMed(state);

      return padEditorMatMed.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      // const { matMeds, prescriptions, padDetails } = action.payload;
      const { currentPadItemMatMeds, previousPadItemMatMeds } = action.payload;

      const padEditorMatMed = new PadItemMatMed(state);

      return padEditorMatMed
        .prepare(currentPadItemMatMeds, previousPadItemMatMeds)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_UPDATE`: {
      const { padPrescriptions, padDetails } = action.payload.data;

      const padEditorMatMed = new PadItemMatMed(state);

      // prettier-ignore
      return padEditorMatMed
        .update(padPrescriptions, padDetails)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
